// NPM Imports
import { createStore, compose, applyMiddleware } from "redux";
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";

// Internal Imports
import Reducer from "./reducers";

const middleware = [thunk];
const logger = createLogger({
  duration: true,
});

if (process.env.REACT_APP_ENVIRONMENT !== "PRODUCTION") {
  middleware.push(logger);
}

const store = createStore(
  Reducer,
  compose(
    applyMiddleware(...middleware),
    typeof window === "object" &&
      typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== "undefined"
      ? window.__REDUX_DEVTOOLS_EXTENSION__({
          serialize: true,
          trace: true,
          traceLimit: 25,
        })
      : f => f,
  ),
);

export default store;
